import React, { memo, useEffect, useState, useCallback } from 'react';
import styles from './gpsLoader.module.scss';
import ListHeader from '../../../shared/components/ListHeader';
import ListNotFound from '../../../shared/components/ListNotFound';
import FilterGps from '../FilterGps';
import ListGps from './subcomponents/ListGps';
import { useTranslation } from 'react-i18next';
import { defaultLimit, defaultPage } from '../../../app/conf';
import AddGpsMenu from '../../components/AddGpsMenu/AddGpsMenu';

export const defaultFilters = {
    full_simcards: 1,
    full_status: 1,
    full_devices: 1,
    full_assigned: 1,
    full_company: 1,
    limit: defaultLimit,
    page: defaultPage
};


export let stockViewFilters = {
    ...defaultFilters
};


export const updateStockViewFilters = (filters) => {
    stockViewFilters = {
        ...stockViewFilters,
        ...filters
    };
    return stockViewFilters;
};

const GpsLoader = ({
    getGpsDevicesRequest,
    setStateGps,
    setGpsFilters,
    setGpsSelected,
    gps: { fetching, gps_devices, total, submitSuccess },
    history,
    filtersoUseInQuery
}) => {
    const { t } = useTranslation(['home', 'devices']);

    const [page, setPage] = useState(defaultFilters.page);

    const getMoreItems = () => {
        const _page = page + 1;
        
        const stockFilters = { 
            ...stockViewFilters, 
            ...filtersoUseInQuery,
            page: _page 
        };
        
        setPage(_page);
        getGpsDevicesRequest(stockFilters);
    };

    const getGPS = useCallback(() => {
        setStateGps({ gps_devices: [] });
        setPage(defaultFilters.page);
        
        const requestFilters = { 
            ...stockViewFilters, 
            ...filtersoUseInQuery 
        };
        
        getGpsDevicesRequest(requestFilters);
    }, [setStateGps, getGpsDevicesRequest, filtersoUseInQuery]);

    useEffect(() => {
        getGPS();
    }, [getGPS]);

    useEffect(() => {
        if (submitSuccess) {
            getGPS();
        }
    }, [getGPS, submitSuccess]);

    useEffect(() => {
        return () => {
            setStateGps({ gps_devices: [], total: 0, fetching: false });
        };
    }, [setStateGps, setGpsFilters]);

    return (
        <>
        <div className={styles.header}>
        <FilterGps  isStockGps={true} showCreateButton={false} setGpsFilters={setGpsFilters} />
        <AddGpsMenu style={styles.btnMenu} />
        </div>
           
            <div className={styles.content}>
                <ListHeader  className={styles.listHeader}>
                <div> Creación </div>
                    <div> {t('home:name')} </div>
                    <div> Modelo </div>
                    <div> {t('home:device')} </div>
                    <div> {t('home:simcard')} </div>
                    <div className={styles.textAlignCenter} > {t('home:protocol_version')} </div>
                    <div> {t('home:status')} </div>
                    <div></div>
                    <div className={styles.textAlignCenter}> {t('devices:enabled')} </div>
                    
                </ListHeader>
                {(fetching || gps_devices.length > 0) && (
                    <ListGps
                        gps_devices={gps_devices}
                        fetching={fetching && page === 1}
                        totalItems={total}
                        fetchingMoreItems={fetching && page > 1}
                        onScrollBottomAction={getMoreItems}
                        submitSuccess={submitSuccess}
                        setGpsSelected={setGpsSelected}
                        history={history}
                    />
                )}
                {!fetching && gps_devices.length === 0 && <ListNotFound />}
            </div>
        </>
    );
};

export default memo(GpsLoader);
